import { PRIMARY_PURPLE } from "@podcastsoundboard/ps-lib/colors"

// Theme constants kept from the old MUI theme; colors now live in
// CSS variables driven by the Tailwind preset (ps-lib/tailwind.preset.cjs).

export const freesoundOrange = "#eb666a"

// these values need to match
export const darkSvgBackground = "#0f0916"
export const lightSvgBackground = "#faf7fb"

export const DEFAULT_COLOR_LIGHT_PRIMARY = PRIMARY_PURPLE
